import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaStarOfLife } from "react-icons/fa6";
import { FiUpload } from "react-icons/fi";
import "./Add_Complaint.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import dayjs from "dayjs";

export default function OrderDetails_Complaint({
  complaintDetails,
  setComplaintDetails,
  isEditable,
  isEditMode
}) {
  const location = useLocation();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState("");
  const [isOpenComplaintOpen, setIsOpenComplaintOpen] = useState(false);

  const formatDate = (date) => {
    return dayjs(date).format("DD-MM-YYYY");
  };

  const formatDatecreate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const createdDate = complaintDetails?.createdDate || new Date().toISOString();
  const daysAgo = moment().diff(moment(createdDate), "days");

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(number);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "location") {
      // Handle location input - can be string or lat,lng pair
      if (value.includes(",")) {
        const [lat, lng] = value.split(",").map(item => parseFloat(item.trim()));
        setComplaintDetails({
          ...complaintDetails,
          location: {
            latitude: lat || 0,
            longitude: lng || 0
          }
        });
      } else {
        setComplaintDetails({
          ...complaintDetails,
          location: value
        });
      }
    } else {
      setComplaintDetails({
        ...complaintDetails,
        [name]: value
      });
    }
  };

  const handleLeadChange = (e) => {
    const { name, value } = e.target;
    setComplaintDetails(prev => ({
      ...prev,
      complaintleadStatus: {
        ...prev.complaintleadStatus,
        [name]: value
      }
    }));
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const locationDisplayValue = () => {
    if (!complaintDetails?.location) return "";
    
    if (typeof complaintDetails.location === "object") {
      return `${complaintDetails.location.latitude}, ${complaintDetails.location.longitude}`;
    }
    return complaintDetails.location;
  };

  return (
    <>
      <form>
        <div className="plan-details-container-border-complaint mt-5 text-center ms-5">
          <p style={{ fontSize: "13px" }} className="mt-3">
            Complaint -{" "}
            <span className="text-primary">
              {complaintDetails?.complaintType || "N/A"}
            </span>{" "}
            Customer Affected -{" "}
            <span className="text-primary">
              {complaintDetails?.complaintcustomerAffected || "N/A"} @{" "}
            </span>
            Location -{" "}
            <span className="text-primary">
              {locationDisplayValue() || "N/A"}
            </span>
          </p>
          <p style={{ fontSize: "13px" }} className="mb-3">
            Complaint Open Date -{" "}
            <span className="text-primary">
              {formatDatecreate(complaintDetails?.createdDate)} ,{" "}
            </span>{" "}
            Complaint Open Last -{" "}
            <span className="text-primary">{daysAgo} Days</span>
          </p>
        </div>

        <Row className="text-start lead-id-row mb-4 mt-4 ms-4">
          <p className="ps-5 paragraph-lead-id">
            Complaint ID -{" "}
            <span className="text-primary">{complaintDetails?.leadId || "N/A"}</span>
            <span className="lead-start-date">
              {" "}
              Started Date & Time -
              <span className="text-primary">
                {formatDate(complaintDetails?.createdDate)}
              </span>
            </span>
          </p>
        </Row>

        <Row className="ms-3">
          <Col sm={12} md={6} className="text-start">
            <label>Customer Affected</label>
            <br />
            <input
              type="text"
              style={{ textTransform: "capitalize" }}
              className="form-input"
              placeholder="Enter Customer Name"
              value={complaintDetails?.complaintcustomerAffected || ""}
              onChange={handleChange}
              disabled={!isEditable}
              name="complaintcustomerAffected"
            />
          </Col>

          <Col sm={12} md={6} className="text-start">
            <label>Complaint Type</label>
            <br />
            <input
              type="text"
              style={{ textTransform: "capitalize" }}
              className="form-input complaint-type"
              placeholder="Enter Complaint type"
              value={complaintDetails?.complaintType || ""}
              onChange={handleChange}
              disabled={!isEditable}
              name="complaintType"
            />
          </Col>
        </Row>

        <Row className="ms-3">
          <Col xs={12} md={6} className="text-start">
            <label>Address</label>
            <br />
            <textarea
              type="text"
              style={{ textTransform: "capitalize", resize: "none" }}
              className="box address-enquiry"
              placeholder="Enter Installation Address"
              value={complaintDetails?.complaintaddress || ""}
              onChange={handleChange}
              disabled={!isEditable}
              name="complaintaddress"
            />
          </Col>
          <Col>
            <Row>
              <Col xs={12} md={6} className="text-start">
                <label>Dependent</label>
                <br />
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={complaintDetails?.complaintnetwork || false}
                    onChange={(e) => 
                      setComplaintDetails({
                        ...complaintDetails,
                        complaintnetwork: e.target.checked
                      })
                    }
                    disabled={!isEditable}
                  />
                  <span className="checkbox-complaint-margin">Network Team</span>
                </label>
              </Col>
              <Col xs={12} md={6} className="text-start">
                <Row className="checkbox-complaint-top">
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={complaintDetails?.complaintfiber || false}
                      onChange={(e) => 
                        setComplaintDetails({
                          ...complaintDetails,
                          complaintfiber: e.target.checked
                        })
                      }
                      disabled={!isEditable}
                    />
                    <span className="checkbox-complaint-margin">Fiber Team</span>
                  </label>
                </Row>
              </Col>
            </Row>
            <Row>
              <Row>
                <Col xs={12} md={6} className="text-start">
                  <label>
                    Contact Number
                    <sup>
                      <FaStarOfLife size={7} />
                    </sup>
                  </label>
                  <br />
                  <input
                    type="tel"
                    onKeyDown={(e) => {
                      if (
                        ["e", "E", "+", "-"].includes(e.key) ||
                        (e.key &&
                          !/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight")
                      ) {
                        e.preventDefault();
                      }
                    }}
                    value={complaintDetails?.complaintcontactNum || ""}
                    onChange={handleChange}
                    disabled={!isEditable}
                    required
                    placeholder="+91"
                    className="form-input"
                    name="complaintcontactNum"
                                          maxLength={10}

                  />
                  {error && <p style={{ color: "red" }}>{error}</p>}
                </Col>
                <Col xs={12} md={6} className="text-start">
                  <label>Location</label>
                  <br />
                  <input
                    className="field form-input"
                    type="text"
                    value={locationDisplayValue()}
                    onChange={handleChange}
                    disabled={!isEditable}
                    name="location"
                    placeholder="Enter latitude,longitude or address"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} className="text-start">
                  <label>Additional Charge</label>
                  <br />
                  <input
                    className="field form-input"
                    type="text"
                    value={complaintDetails?.complaintadditionalCharges || ""}
                    onChange={handleChange}
                    disabled={!isEditable}
                    name="complaintadditionalCharges"
                  />
                </Col>
                <Col xs={12} md={6} className="text-start">
                  <label>Complaint Status</label>
                  <br />
                  <button
                    type="button"
                    name="leadStatus"
                    disabled={!isEditable}
                    value={complaintDetails?.leadStatus || ""}
                    onClick={() => setIsOpenComplaintOpen(true)}
                    style={{
                      backgroundColor: "#fbdc6e",
                      color: "rgb(94, 94, 14)",
                    }}
                    className="form-input converted-form"
                  >
                    {complaintDetails?.leadStatus || "Open"}
                  </button>

                  {isOpenComplaintOpen && (
                    <div className="overlay1-converted">
                      <div className="modal1-converted">
                        <Container>
                          <button
                            className="close-btn1"
                            onClick={() => setIsOpenComplaintOpen(false)}
                          >
                            <span style={{ fontSize: "20px" }}> &times; </span>
                          </button>

                          <div className="open-button border">
                            <h5>{complaintDetails?.leadStatus || "Open"}</h5>
                          </div>

                          <textarea
                            style={{
                              textTransform: "capitalize",
                              resize: "none",
                            }}
                            placeholder="Enter Notes"
                            className="converted-textbox"
                            name="complaintnotes"
                            onChange={handleLeadChange}
                            value={
                              complaintDetails?.complaintleadStatus?.complaintnotes || ""
                            }
                          />
                          <div className="upload-section">
                            <label className="upload-btn">
                              <FiUpload className="upload-icon" />
                              Upload Image
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                hidden
                              />
                            </label>
                            {selectedFile && (
                              <p className="file-name">{selectedFile.name}</p>
                            )}
                          </div>

                          <Row>
                            <Col className="date-update-textbox">
                              <label>Next Follow Up Date</label>
                              <br />
                              <input
                                type="date"
                                className="field form-input"
                                value={
                                  complaintDetails?.complaintleadStatus
                                    ?.complaintnextFollowUpDate || ""
                                }
                                onChange={handleLeadChange}
                                name="complaintnextFollowUpDate"
                              />
                            </Col>
                            <Col className="uploadbtn-complaint">
                              <button type="button" className="blue-btn">
                                Upload
                              </button>
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </Row>
          </Col>
        </Row>
      </form>
    </>
  );
}